'use client';

import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

const NAVIGATION_HISTORY_KEY = 'starky-nav-history';

function addToNavigationHistory(path: string) {
  if (typeof window === 'undefined') return;
  try {
    const stored = sessionStorage.getItem(NAVIGATION_HISTORY_KEY);
    const history: string[] = stored ? JSON.parse(stored) : [];

    // Don't add duplicate consecutive entries
    if (history[history.length - 1] !== path) {
      history.push(path);
      // Keep only last 10 entries to avoid memory issues
      if (history.length > 10) {
        history.shift();
      }
      sessionStorage.setItem(NAVIGATION_HISTORY_KEY, JSON.stringify(history));
    }
  } catch (error) {
    console.warn('Could not save navigation history:', error);
  }
}

export function NavigationTracker() {
  const pathname = usePathname();

  useEffect(() => {
    // Track the current page in our navigation history
    const fullPath = window.location.pathname + window.location.search + window.location.hash;
    addToNavigationHistory(fullPath);
  }, [pathname]);

  // This component doesn't render anything
  return null;
}
